// extracted by mini-css-extract-plugin
export var button = "_de-0";
export var icon = "_de-1";